export enum CreditTierName {
    EXCELLENT = 'Excellent',
    VERY_GOOD = 'Very Good',
    GOOD = 'Good',
    FAIR = 'Fair',
    POOR = 'Poor'
}

export enum CreditTierType {
    NEW = 'new',
    USED = 'used'
}
